<template>
  <div class="contens">
    <div class="cons">
  
        <h2>汽车建当复核</h2>
  
      <div class="header_title">
        <span class="header_piao">票号：
          <input type="number" v-model="piaoNum" />
        </span>
        <span>填表日期：{{items.dates}}</span>
      </div>

     <table width="70%">
       <tr>
         <td width="15%">车主</td>
         <td><input type="text" v-model="name" /></td>
         <td>车辆状态（类别）</td>
         <td><input type="text" v-model="radio" /></td>
       </tr>
       <tr>
         <td>职业</td>
         <td>
           <input type="text" v-model="occuPation" />
         </td>
         <td>电话</td>
         <td><input type="number" v-model="tel" maxlength="11" /></td>
       </tr>
       <tr>
         <td>车主身份证号</td>
         <td colspan="3">
           <input type="number" v-model="IdCard" maxlength="18" />
         </td>
       </tr>
     </table>

     <!-- 车贷详情 -->
     <table width="70%">
        <tr>
         <td rowspan="2" width="15%">车贷详情</td>
         <td rowspan="2" width="15%">抵押权人</td>
         <td rowspan="2"><input type="text" v-model="creditor" /></td>
         <td width="15%">车贷总额</td>
         <td><input type="number" v-model="price" /></td>
         <td width="15%">月供</td>
         <td><input type="number" v-model="repayment" /></td>
       </tr>
       <tr>
         <td>车贷余额</td>
         <td><input type="number" v-model="remaining" /></td>
         <td>剩余期数</td>
         <td><input type="number" v-model="RestPeriods" /></td>
       </tr>
       
       <!-- 车辆详情 -->
       <tr>
         <td rowspan="5">车辆详情</td>
         <td>购车总额</td>
         <td><input type="number" v-model="total" /></td>
         <td colspan="2">发票价</td>
         <td colspan="2"><input type="number" v-model="invoiceCost" /></td>
       </tr>
       <tr>
         <td>过户次数</td>
         <td><input type="number" v-model="transferOwnership" /></td>
         <td>车牌号</td>
         <td colspan="3"><input type="text" v-model="plateNumber" /></td>
       </tr>
       <tr>
         <td>注册日期</td>
         <td><input type="text" v-model="recordDate" /></td>
         <td>行驶里程/km</td>
         <td colspan="3"><input type="number" v-model="mileage" /></td>
       </tr>
       <tr>
         <td>是否事故车</td>
         <td colspan="5"><input type="text" v-model="radio1" /></td>
       </tr>
       <tr>
         <td>综合车况</td>
         <td colspan="2">{{values == 1?"车况较差":values == 2?"车况一般":"车况良好"}}</td>
         <td>经办人意见</td>
         <td colspan="2">{{opinion}}</td>
       </tr>

       <!-- 核对证件 -->
       <tr>
         <td rowspan="4">核对证件</td>
         <td>证件</td>
         <td colspan="5">{{checkList}}</td>
       </tr>
       <tr>
         <td rowspan="2">保险到期日</td>
         <td colspan="5">交强险到期：<input type="text" v-model="StrongRisk" /></td>
       </tr>
       <tr>
         <td colspan="5">商业险到期：<input type="text" v-model="commercialInsurance" /></td>
       </tr>
       <tr>
         <td>违章未处理</td>
         <td colspan="5"><input type="text" v-model="IllegalProcessing" /></td>
       </tr>

       <!-- 制表日期 -->
       <tr>
         <td rowspan="4">制表日期（市场及第三方估值）</td>
         <td>新车在售价格/元</td>
         <td><input type="number" v-model="NewCarPrice" /></td>
         <td>保值率</td>
         <td><input type="text" v-model="keepValue" /></td>
         <td>客户期望借款</td>
         <td><input type="number" v-model="expect" /></td>
       </tr>
       <tr>
         <td rowspan="3">第三方转让过户参考价（取平均）</td>
         <td colspan="2">车300：<input type="number" v-model="vehicles" /></td>
         <td rowspan="3">车辆余值（市场价减去车辆负债减去违章）</td>
         <td rowspan="3" colspan="2"><input type="number" v-model="residualValue" /></td>
       </tr>
       <tr>
         <td colspan="2">汽车之家：<input type="number" v-model="atHm" /></td>
       </tr>
       <tr>
         <td colspan="2">待接入</td>
       </tr>
     </table>

     <!-- 当物估值 -->
     <table width="70%">
       <tr>
         <td>当物估值</td>
         <td><input type="number" v-model="overallValuation" /></td>
         <td>折当率/%</td>
         <td><input type="text" v-model="FoldWhen" /></td>
         <td>典当天数/天</td>
         <td><input type="text" v-model="det" /></td>
       </tr>
       <tr>
         <td>典当金额</td>
         <td><input type="number" v-model="sum" /></td>
         <td>典当期限</td>
         <td><input type="text" v-model="startDate" /></td>
         <td>至</td>
         <td><input type="text" v-model="DateClosed" /></td>
       </tr>

       <tr>
         <td>典当综合费</td>
         <td colspan="3"><input type="number" v-model="comprehensive" /></td>
         <td>典当利息</td>
         <td colspan="2"><input type="number" v-model="lx" /></td>
       </tr>
       <tr>
         <td colspan="6">
           经办人（署名）：{{items.agent}}
         </td>
       </tr>
       <tr>
         <td colspan="6">
          复核人（署名）：{{username}}
          <div class="re">复核日期：{{date}}</div>
         </td>
       </tr>

     </table>
     <div class="con_title">**红色字体是可以修改的内容,如果内容没有错误请直接点击提交复核，内容信息有误可直接点击红色字体修改然后提交即可**</div>

    </div>
    <div class="con">
      <el-button type="primary" @click="tjClick"
        >提交复核<i class="el-icon-upload el-icon--right"></i
      ></el-button>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  name: "Cards",
  data() {
    return {
      id: "", //被点击要复核的id

      ACCESS_TOKEN: "", //ACCESS_TOKEN
      items: [], //请求回来的数据
      token: "", //token
      username: "", //当前登录的账号

      //复核内容
      name:"",  //车主姓名
      piaoNum:"", //票号
      IdCard:"", //身份证号
      radio:"", //车辆状态
      occuPation:"", //车主职业
      tel:"", //电话
      creditor:"",  //债权人
      price:"",  //贷款总额
      remaining:"", //车贷剩余金额
      repayment:"", //月供
      RestPeriods:"", //车贷剩余期数
      total:"",  //购车总金额
      invoiceCost:"", //发票价
      transferOwnership:"", //过户次数
      plateNumber:"", //车牌号
      recordDate:"", //车辆注册日期
      mileage:"",  //行驶里程
      radio1:"", //是否事故车
      values:"",  //综合车况
      opinion:"", //经办人意见
      checkList:"", //证件
      StrongRisk: "", //交强险
      commercialInsurance: "", //商业险到期日期
      IllegalProcessing: "", //违章情况
      NewCarPrice: "", //新车在售价格
      keepValue: "", //保值率
      expect: "", //客户期望借款金额
      vehicles: "", //车300 估值
      atHm: "", //汽车之家估值
      residualValue: "", //剩余价值
      overallValuation: "", //车辆最终估值
      FoldWhen: "", //折当率
      sum: "", //典当金额
      startDate:"", //典当开始日期
      DateClosed:"",//典当到期日期
      det: "", // 选择典当的天数
      date:"",  //当前日期
      comprehensive:"", //典当综合费
      lx:"", //典当利息
    };
  },
  methods: {
    getData() {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: 'db.collection("car_data").doc("' + this.id + '").get()',
        })
        .then((res) => {
          if(res.data.errcode !== 0){
            return  this.$notify.error({
              title: '错误提示',
              message: '密钥过期啦，请刷新页面'
            });
          }
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          this.items = res.data.data[0];
          this.piaoNum = res.data.data[0].piaonum;
          this.IdCard = res.data.data[0].IdCard;
          this.name = res.data.data[0].name;
          this.radio = res.data.data[0].radio;
          this.occuPation = res.data.data[0].occuPation;
          this.tel = res.data.data[0].tel;
          this.creditor = res.data.data[0].creditor;
          this.price = res.data.data[0].price;
          this.remaining = res.data.data[0].remaining;
          this.repayment = res.data.data[0].repayment;
          this.RestPeriods = res.data.data[0].RestPeriods;
          this.total = res.data.data[0].total;
          this.invoiceCost = res.data.data[0].invoiceCost;
          this.transferOwnership = res.data.data[0].transferOwnership;
          this.plateNumber = res.data.data[0].plateNumber;
          this.recordDate = res.data.data[0].recordDate;
          this.mileage = res.data.data[0].mileage;
          this.radio1 = res.data.data[0].radio1;
          this.values = res.data.data[0].values;
          this.opinion = res.data.data[0].opinion;
          this.checkList = res.data.data[0].checkList;
          this.StrongRisk = res.data.data[0].StrongRisk;
          this.commercialInsurance = res.data.data[0].commercialInsurance;
          this.IllegalProcessing = res.data.data[0].IllegalProcessing;
          this.NewCarPrice = res.data.data[0].NewCarPrice;
          this.keepValue = res.data.data[0].keepValue;
          this.expect = res.data.data[0].expect;
          this.vehicles = res.data.data[0].vehicles;
          this.atHm = res.data.data[0].atHm;
          this.residualValue = res.data.data[0].residualValue;
          this.overallValuation = res.data.data[0].overallValuation;
          this.FoldWhen = res.data.data[0].FoldWhen;
          this.sum = res.data.data[0].sum;
          this.startDate = res.data.data[0].startDate;
          this.DateClosed = res.data.data[0].DateClosed;
          this.det = res.data.data[0].det;
          this.comprehensive = res.data.data[0].comprehensive;
          this.lx = res.data.data[0].lx;

        });
    },

    tjClick() {
      this.axios
        .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query:
            `db.collection("car_data").doc("${this.id}").update({data:{
              name:"${this.name}",
              piaonum:"${this.piaoNum}",
              IdCard:"${this.IdCard}",
              radio:"${this.radio}",
              occuPation:"${this.occuPation}",
              tel:"${this.tel}",
              creditor:"${this.creditor}",
              price:"${this.price}",
              remaining:"${this.remaining}",
              repayment:"${this.repayment}",
              RestPeriods:"${this.RestPeriods}",
              total:"${this.total}",
              invoiceCost:"${this.invoiceCost}",
              transferOwnership:"${this.transferOwnership}",
              plateNumber:"${this.plateNumber}",
              recordDate:"${this.recordDate}",
              mileage:"${this.mileage}",
              radio1:"${this.radio1}",
              StrongRisk:"${this.StrongRisk}",
              commercialInsurance:"${this.commercialInsurance}",
              IllegalProcessing:"${this.IllegalProcessing}",
              NewCarPrice:"${this.NewCarPrice}",
              keepValue:"${this.keepValue}",
              expect:"${this.expect}",
              vehicles:"${this.vehicles}",
              atHm:"${this.atHm}",
              residualValue:"${this.residualValue}",
              overallValuation:"${this.overallValuation}",
              FoldWhen:"${this.FoldWhen}",
              det:"${this.det}",
              sum:"${this.sum}",
              startDate:"${this.startDate}",
              DateClosed:"${this.DateClosed}",
              reviewer:"${this.username}",
              CheckTheDate:"${this.date}",
              comprehensive:"${this.comprehensive}",
              lx:"${this.lx}",
              }
            })`,
        })
        .then(ref => {
          if (ref.data.errcode == 0) {
            this.addRecord()

            this.$notify({
              title: "复核成功",
              message: "订单复核成功",
              type: "success",
            });

            setTimeout(() => {
              this.$router.push("/Car/reviews");
            }, 2000);
          }
        });
    },

    //添加流水
    addRecord(){
       this.axios
        .post("/api/tcb/databaseadd?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("yxus_record").add({data:{
              stas:"建当",
              ticketnumber:"${this.piaoNum}",
              name:"${this.name}",
              itemname:"汽车-${this.plateNumber}",
              xuday:"${this.date}",
              overdate:"${this.startDate}",
              enddate:"${this.DateClosed}",
              dday:"${this.det}",
              pri:"${this.sum}",
              xupri:"${this.comprehensive}",
              lx:"${this.lx}",
              ytdy:"0",
              pena:"0",
              yspri:"${this.items.isType == true ? Number(this.comprehensive) : Number(this.comprehensive) + Number(this.sum / this.items.command)}",
              rece:"${this.items.isType == true ? Number(this.comprehensive) : Number(this.comprehensive) + Number(this.sum / this.items.command)}",
              couqons:"不适用",
              couqonmoney:"0",
              xuname:"${this.username}"
          }})`
    })

    },
  },
  created() {
    this.id = this.$route.query.id; //拿到要复核的id
    // this.ACCESS_TOKEN = localStorage.getItem("ACCESS_TOKEN"); //ACCESS_TOKEN
       //获取到this.ACCESS_TOKEN
     this.getTokens()

      //获取当前登录的用户数据
    this.getUserToken()

     this.date = dayjs().format("YYYY-MM-DD"); //获取到今天的日期
  },
  mounted() {
    setTimeout(()=>{
      this.getData();

    this.username = this.userData.username
    },700)
    
  },
};
</script>
<style scoped>
 input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
    }
    input[type="number"]{
        -moz-appearance: textfield;
    }
.contens {
  width: 100%;
  margin: 10px auto;
  background-color: #ffffff;
}
.cons {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px 0;

}
.con {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding: 20px 20px;
}
table {
  border-collapse: collapse;
}
td {
  height: 35px;
  border: 1px solid black;
  font-size: 15px;
  text-align: center;
}
.header_title{
  width: 68%;
  display: flex;
  flex-direction: row;
  justify-content:space-between
}
td input {
  font-size: 19px;
  outline: none;
  border: 0;
  color: #c44257;
  width: 90%;
  text-align: center;
}
input{
  font-size: 19px;
  outline: none;
  border: 0;
  color: #c44257;
}
.header_piao{
  display: flex;
  flex-direction: row;
}
.re{
  margin-top: 10px;
}
.con_title{
  color: #c44257;
  margin-top: 20px;
}
</style>
